import * as React from 'react';
import Typography from '@mui/material/Typography';
import { Container, Alert, Snackbar, tableCellClasses, Button, Box, IconButton, Select, MenuItem } from '@mui/material';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import api, { fetchProductionRepairReplacements, updateProductionRepairReplacement, emailProductionRepairReplacementPdf } from "../services/ApiService";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SendIcon from '@mui/icons-material/Send';
import DeleteConfirmDialog from '../components/DeleteConfirmDialog';
import SendEmailConfirmDialog from '../components/SendEmailConfirmDialog';
import CircularProgress from '@mui/material/CircularProgress';
import DataTable from '../components/DataTable';
import { z } from "zod";
import { FormModal, RHFTextField } from "../components/form";

export function ProductionRepairReplacement() {
    const [snackbar, setSnackbar] = React.useState({ open: false, message: '', severity: 'success' }); // Snackbar state
    const [sendingEmailId, setSendingEmailId] = React.useState(null);
const [deleteConfirmOpen, setDeleteConfirmOpen] = React.useState(false);
const [sendConfirmOpen, setSendConfirmOpen] = React.useState(false);
const [selectedActionSaleId, setSelectedActionSaleId] = React.useState(null);

// Open delete confirmation
const handleDeleteClick = (saleId) => {
    setSelectedActionSaleId(saleId);
    setDeleteConfirmOpen(true);
};

// Confirm delete
const confirmDelete = async () => {
    if (selectedActionSaleId) {
        await handleDelete(selectedActionSaleId);
    }
    setDeleteConfirmOpen(false);
    setSelectedActionSaleId(null);
};

// Open send email confirmation
const handleSendClick = (saleId) => {
    setSelectedActionSaleId(saleId);
    setSendConfirmOpen(true);
};

// Confirm send email
const confirmSendEmail = async () => {
    if (selectedActionSaleId) {
        await handleSendEmail(selectedActionSaleId);
    }
    setSendConfirmOpen(false);
    setSelectedActionSaleId(null);
};

    const fetchTrucks = async () => {
        try {
            const response = await fetchProductionRepairReplacements();
            setProductionData(response.data);
            showSnackbar('Production fetched successfully', 'success');
        } catch (error) {
            const errorMessage =
                error.response?.statusText || error.message || 'Error fetching production';
            showSnackbar(`Failed to fetch production: ${errorMessage}`, 'error');
        }
    };

    const handleSendEmail = async (saleId) => {
          setSendingEmailId(saleId);

        try {
            await emailProductionRepairReplacementPdf(saleId, {});
            alert("Email sent successfully!");
        } catch (error) {
            console.error("Email error:", error);
            alert("Failed to send email.");
        }finally {
    setSendingEmailId(null);
  }
    };

    React.useEffect(() => {
        fetchTrucks();
    }, []);

    const showSnackbar = (message, severity) => {
        setSnackbar({ open: true, message, severity });
    };

    const handleSnackbarClose = () => {
        setSnackbar({ ...snackbar, open: false });
    };
    const [productionData, setProductionData] = React.useState([])
    const [modalOpen, setModalOpen] = React.useState(false);
    // Save productionData to localStorage on update
    React.useEffect(() => {
        localStorage.setItem('production', JSON.stringify(productionData));
        console.log(productionData, 'productionData');

    }, [productionData]);

    const [editModalOpen, setEditModalOpen] = React.useState(false);
    const [selectedProduction, setSelectedProduction] = React.useState(null);
    const handleEditOn = (device) => {
        setSelectedProduction(device);
        setEditModalOpen(true);
    };

    const handleEditClose = () => {
        setEditModalOpen(false);
        setSelectedProduction(null);
    };
    const handleDelete = async (id) => {
        try {
            await api.delete(`/production-repair-replacement/${id}/`);
            showSnackbar("Customer deleted successfully", "success");
        } catch (error) {
            showSnackbar("Failed to delete customer", "error");
            console.error(error);
        }
    };

    const handleSave = async (newEmployee) => {
        try {
            const response = await api.post('/production-repair-replacement/', newEmployee);
            setProductionData((prev) => [...prev, response.data]);
        } catch (error) {
            console.error("Error saving employee:", error);
        }
    };

    const handleExport = () => {
  const doc = new jsPDF('l', 'mm', 'a3');

  // Title
  doc.setFontSize(18);
  doc.text('Production Repair/Replacement Report', 14, 16);

  // Table Headers (match your UI table, excluding "Action")
  const columns = [
    'Production Repair/Replacement #',
    'Technical Repair/Replacement #',
    'Customer Support Repair/Replacement #',
    'Remarks',
    'Document',
    'Closed At',
    'Status',
  ];

  // Table Data
  const tableData = productionData.map(record => [
    record.id,
    record.technical_repair_replacement || '',
    record.customer_support_repair_replacement || '',
    record.remarks || '',
    record.document_url ? "Available" : "Not Available",
    record.status === "Close" ? record.updated_at?.slice(0, 19).replace("T", " ") : "",
    record.status || '',
  ]);

  // Generate table
  doc.autoTable({
    head: [columns],
    body: tableData,
    startY: 30,
    styles: {
      fontSize: 9,
      cellPadding: 2,
    },
    columnStyles: {
      0: { cellWidth: 50 },  // Production Repair/Replacement #
      1: { cellWidth: 50 },  // Technical Repair/Replacement #
      2: { cellWidth: 60 },  // Customer Support Repair/Replacement #
      3: { cellWidth: 70 },  // Remarks
      4: { cellWidth: 40 },  // Document
      5: { cellWidth: 40 },  // Closed At
      6: { cellWidth: 30 },  // Status
    },
    theme: 'grid',
    didDrawPage: function () {
      doc.setFontSize(18);
      doc.text('Production Repair/Replacement Report', 14, 16);
    },
  });

  doc.save('Production_Repair_Replacement_Report.pdf');
};
    const EditProductionModal = ({ open, handleClose, device }) => {
        return (
            <FormModal
                open={open}
                onClose={handleClose}
                title="Edit Production"
                schema={z.object({ remarks: z.string().optional() })}
                defaultValues={{ remarks: device?.remarks ?? "" }}
                onSubmit={async (data) => {
                    const fd = new FormData();
                    Object.entries(data).forEach(([k, v]) => { if (v !== null && v !== undefined && v !== "") fd.append(k, v); });
                    try {
                        await updateProductionRepairReplacement(device.id, fd);
                        showSnackbar("Production updated successfully", "success");
                        fetchTrucks();
                    } catch (err) {
                        showSnackbar("Production update failed", "error");
                        throw err;
                    }
                }}
                submitLabel="Update"
                width={400}
            >
                {({ control }) => (
                    <>
                        <Box sx={{ mb: 2.5, pb: 1.5, borderBottom: "1px solid", borderColor: "divider", display: "flex", gap: 3, flexWrap: "wrap" }}>
                            <Typography variant="caption" color="text.secondary">Created: {device?.created_at?.slice(0, 19).replace("T", " ")}</Typography>
                            <Typography variant="caption" color="text.secondary">Updated: {device?.updated_at?.slice(0, 19).replace("T", " ")}</Typography>
                        </Box>
                        <RHFTextField control={control} name="remarks" label="Remarks" multiline rows={4} />
                    </>
                )}
            </FormModal>
        );
    };

    const updateProduction = async (updatedProduction, id) => {
        const formData = new FormData();
        for (const key in updatedProduction) {
            formData.append(key, updatedProduction[key]);
        }
        try {
            await updateProductionRepairReplacement(id, formData);
            showSnackbar('Production updated successfully', 'success');
        } catch (error) {
            showSnackbar('Failed to update device', 'error');
        }
    };
    const handleStatusChange = async (saleId, newStatus, sale) => {
        const updatedSale = { ...sale, status: newStatus };

        try {
            await updateProductionRepairReplacement(saleId, updatedSale);

            // Update state in frontend
            setProductionData((prevData) =>
                prevData.map((item) =>
                    item.id === saleId ? { ...item, status: newStatus } : item
                )
            );

            showSnackbar('Status updated successfully', 'success');
        } catch (error) {
            console.error('Failed to update status:', error);
            showSnackbar('Failed to update status', 'error');
        }
    };

    return (
        <Container maxWidth="xl" sx={{ m: 2 }}>
            {editModalOpen && selectedProduction && <EditProductionModal
                open={editModalOpen}
                handleClose={handleEditClose}
                device={selectedProduction}
            />}
            <DataTable
                title="Production Repair/Replacement List"
                columns={[
                    { key: 'id', label: 'Production R/R #' },
                    { key: 'technical_repair_replacement', label: 'Technical R/R #' },
                    { key: 'customer_support_repair_replacement', label: 'CS R/R #' },
                    { key: 'remarks', label: 'Remarks' },
                    { key: 'document_url', label: 'Document', render: (sale) => sale.document_url ? (
                        <a href={`https://crm-backend.monit.tech/${sale.document_url}`} download target="_blank" rel="noopener noreferrer">Download</a>
                    ) : <span style={{ color: '#999' }}>Not Available</span> },
                    { key: 'close_at', label: 'Close At', render: (sale) => (
                        <div style={{ maxHeight: '80px', overflow: 'auto' }}>{sale.status === 'Close' && sale.updated_at?.slice(0, 19).replace("T", " ")}</div>
                    )},
                ]}
                rows={productionData}
                toolbarActions={<Button variant="contained" color="primary" style={{ marginLeft: "10px" }} onClick={handleExport}>Export to PDF</Button>}
                renderActions={(sale) => <>
                    <IconButton color="secondary" size="small" onClick={() => handleEditOn(sale)} sx={{ padding: '6px' }} disabled={sale.status === 'Close'}><EditIcon /></IconButton>
                    <IconButton color="error" size="small" onClick={() => handleDeleteClick(sale.id)} sx={{ padding: '6px', marginLeft: '4px' }} disabled={sale.status === 'Complete'}><DeleteIcon /></IconButton>
                    <IconButton color="primary" size="small" onClick={() => handleSendClick(sale.id)} sx={{ padding: '6px', marginLeft: '4px' }} disabled={sendingEmailId === sale.id}>
                        {sendingEmailId === sale.id ? <CircularProgress size={20} color="inherit" /> : <SendIcon />}
                    </IconButton>
                    <Select value={sale.status} onChange={(e) => handleStatusChange(sale.id, e.target.value, sale)} size="small" sx={{ ml: 1, minWidth: 100 }}>
                        <MenuItem value="Pending">Pending</MenuItem>
                        <MenuItem value="Complete">Complete</MenuItem>
                    </Select>
                </>}
            />
                {/* Delete Confirmation */ }
      <DeleteConfirmDialog
        open={deleteConfirmOpen}
        onClose={() => setDeleteConfirmOpen(false)}
        onConfirm={confirmDelete}
      />

      <SendEmailConfirmDialog
        open={sendConfirmOpen}
        onClose={() => setSendConfirmOpen(false)}
        onConfirm={confirmSendEmail}
      />
            <Snackbar
                open={snackbar.open}
                autoHideDuration={4000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Container>
    );
}
